import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress unhandled promise rejection overlay for API errors
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.response?.status || event.reason?.message?.includes('Network')) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
